// Shared-component strings, namespaced as 'components.<componentName>.<key>'.
export default {
  'components.cleanTextContextMenu.copy': 'คัดลอกข้อความโดยไม่มีแหล่งอ้างอิง',
  'components.cleanTextContextMenu.copied': 'คัดลอกข้อความแล้ว',
  'components.cleanTextContextMenu.failed': 'ไม่สามารถคัดลอกข้อความได้ โปรดลองอีกครั้ง',
  'components.addToMattersPopover.selectMattersLabel': 'เลือกคดี:',
  'components.addToMattersPopover.searchPlaceholder': 'ค้นหาคดี...',
  'components.addToMattersPopover.updateSuccess': 'อัปเดตคดีสำเร็จแล้ว',
  'components.addToMattersPopover.updateError': 'อัปเดตคดีไม่สำเร็จ',
  'components.billingRequiredOverlay.title': 'ต้องดำเนินการเรื่องการเรียกเก็บเงิน',
  'components.billingRequiredOverlay.manageBillingButton': 'จัดการการเรียกเก็บเงิน',
  'components.chat.jsonResponseTitle': 'การตอบกลับแบบ JSON',
  'components.chat.dataOpenedInNewTab': 'เปิดข้อมูลในแท็บใหม่แล้ว',
  'components.chat.textResponseTitle': 'การตอบกลับแบบข้อความ',
  'components.chat.contentOpenedInNewTab': 'เปิดเนื้อหาในแท็บใหม่แล้ว',
  'components.chat.fileOpenedInNewTab': 'เปิดไฟล์ในแท็บใหม่แล้ว',
  'components.chat.failedToOpenNewTab': 'เปิดแท็บใหม่ไม่สำเร็จ',
  'components.chat.failedToFetchUrl': 'ดึงข้อมูลจาก URL ไม่สำเร็จ: {message}',
  'components.chat.referenceDocumentFallback': 'เอกสารอ้างอิง',
  'components.chat.sourcesCount': 'แหล่งที่มา ({count})',
  'components.chat.referencesCount': '{count} การอ้างอิง',
  'components.chat.htmlContentTitle': 'เนื้อหา HTML',
  'components.chat.showMoreLines': 'แสดงเพิ่มเติม ({count} บรรทัด)',
  'components.chatWidget.waitingMessage.justAMoment': 'สักครู่...',
  'components.chatWidget.waitingMessage.fetchingThatForYou': 'กำลังดึงข้อมูลให้คุณ...',
  'components.chatWidget.waitingMessage.hangTight': 'รอสักครู่ กำลังดำเนินการ...',
  'components.chatWidget.waitingMessage.letMeCheck': 'กำลังตรวจสอบ...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond': 'จะใช้เวลาเพียงครู่เดียว...',
  'components.chatWidget.closeChatAriaLabel': 'ปิดแชท',
  'components.chatWidget.openChatAriaLabel': 'เปิดแชท',
  'components.billingRequiredOverlay.defaultMessage':
    'การเรียกเก็บเงินขององค์กรของคุณต้องได้รับการดำเนินการก่อนจึงจะดำเนินการต่อได้ กรุณาติดต่อผู้ดูแลระบบองค์กรของคุณ',
  'components.chatWidget.processingTooltip': 'แชทจะพร้อมใช้งานเมื่อการประมวลผลเสร็จสิ้น',
  'components.chatWidget.messageCopied': 'คัดลอกข้อความแล้ว!',
  'components.chatWidget.copyMessageFailed': 'ไม่สามารถคัดลอกข้อความได้',
  'components.chatWidget.header.title': 'แชท',
  'components.chatWidget.emptyState.title': 'ให้ช่วยอะไรดี?',
  'components.chatWidget.inputPlaceholder': 'พิมพ์ข้อความ...',
  'components.chatWidget.showMoreLines': 'แสดงเพิ่มเติม ({count} บรรทัด)',
  'components.chatWidget.invalidFileUrl': 'URL ของไฟล์ไม่ถูกต้องหรือไม่พบ',
  'components.chatWidget.fileDownloadedSuccessfully': 'ดาวน์โหลดไฟล์สำเร็จ',
  'components.chatWidget.fileDownloadFailed': 'ดาวน์โหลดไฟล์ไม่สำเร็จ: {message}',
  'components.chatWidget.unnamedFile': 'ไฟล์',
  'components.chatWidget.attachmentImageAlt': 'ไฟล์แนบ',
  'components.checklistCard.heading': 'รายการตรวจสอบ',
  'components.downloadLoadingMask.downloading': 'กำลังดาวน์โหลด...',
  'components.emlViewer.fromLabel': 'จาก:',
  'components.emlViewer.toLabel': 'ถึง:',
  'components.emlViewer.ccLabel': 'สำเนาถึง:',
  'components.emlViewer.dateLabel': 'วันที่:',
  'components.emlViewer.attachmentsLabel': 'ไฟล์แนบ:',
  'components.filesSidePanel.favoritesButton': 'รายการโปรด',
  'components.filesSidePanel.historyButton': 'ประวัติ',
  'components.filesSidePanel.untitledPlaceholder': '(ไม่มีชื่อ)',
  'components.filesSidePanel.membersPopoverTitle': 'สมาชิก',
  'components.filesSidePanel.ownerTag': 'เจ้าของ',
  'components.filesSidePanel.modifyGroupTooltip': 'แก้ไขกลุ่ม',
  'components.filesSidePanel.privateGroupWarningTooltip':
    'ความปลอดภัยต่ำ: มองเห็นได้โดยกลุ่มของคุณ',
  'components.filesSidePanel.firmWideWarningTooltip':
    'ไม่ปลอดภัยมาก: มองเห็นได้โดยทั้งบริษัทของคุณ',
  'components.filesSidePanel.publicWarningTooltip': 'ไม่ปลอดภัยมาก: มองเห็นได้โดยทุกคน',
  'components.filesSidePanel.sortByDateLabel': 'เรียงตามวันที่ (ใหม่ไปเก่า)',
  'components.filesSidePanel.sortAlphabeticallyLabel': 'เรียงตามตัวอักษร (A-Z)',
  'components.gettingStartedTour.insiderHero.openLinkLabel': 'เปิด A&GEL Insider',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle': 'การเรียนรู้เครื่องมือใหม่ต้องใช้เวลา',
  'components.gettingStartedTour.insiderHero.basicsCard.copy': 'ทุกสิ่งที่คุณต้องการตั้งแต่วันแรก',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': 'เริ่มต้นจากพื้นฐาน',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': 'เรียนรู้เพิ่มเติม',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy': 'การเปิดตัวและอัปเดตล่าสุด',
  'components.gettingStartedTour.insiderHero.marinaAlt': 'เส้นขอบฟ้ามารีนา',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': 'บทความแนะนำ',
  'components.gettingStartedTour.insiderHero.filesUpload.title': 'อัปโหลดไฟล์',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': 'ดูเพิ่มเติม',
  'components.gettingStartedTour.allCompleted.redoButton': 'ทำทัวร์อีกครั้ง',
  'components.gettingStartedTour.heading': 'เริ่มต้นใช้งาน',
  'components.gettingStartedTour.tourStyles.stepIndicator': 'ขั้นตอนที่ {current} จาก {total}',
  'components.gettingStartedTour.tourStyles.nextDefault': 'ถัดไป →',
  'components.gettingStartedTour.chatTour.step2.nextLabel': 'ปิดและดำเนินการต่อ →',
  'components.gettingStartedTour.chatTour.completeModal.title': 'ทำได้ดีมาก!',
  'components.gettingStartedTour.tourComplete.completeButton': 'เสร็จสิ้น',
  'components.gettingStartedTour.tourComplete.continueButton': 'ไปยัง {title} →',
  'components.gettingStartedTour.playbookTour.completeModal.title': 'ทำได้ดี!',
  'components.gettingStartedTour.playbookTour.step1.openingLabel': 'กำลังเปิด…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': 'เปิดตัวอย่าง →',
  'components.gettingStartedTour.playbookTour.step2.item1':
    '• การเป็นเจ้าของทรัพย์สินทางปัญญาร่วมกัน (ข้อ 17)',
  'components.gettingStartedTour.playbookTour.step2.item2': '• เพิ่มระยะเวลาแก้ไข 14 วัน (ข้อ 8)',
  'components.gettingStartedTour.playbookTour.step2.item3': '• จำกัดขอบเขตข้อห้ามแข่งขัน (ข้อ 27)',
  'components.gettingStartedTour.playbookTour.step3.title': 'คลิกส่งเพื่อสร้างการแก้ไข',
  'components.gettingStartedTour.reviewTour.completeModal.title': 'ยอดเยี่ยม!',
  'components.gettingStartedTour.reviewTour.step4.title':
    'เลือกหมวดหมู่เพื่อจัดระเบียบรายการของคุณ',
  'components.gettingStartedTour.reviewTour.step9.title': 'บันทึกรายการของคุณเพื่อใช้กับเอกสาร',
  'components.gettingStartedTour.reviewTour.step15.nextLabel': 'เสร็จสิ้น',
  'components.gettingStartedTour.scribeTour.completeModal.title': 'ทำได้ดี!',
  'components.gettingStartedTour.scribeTour.step2.title': 'ตั้งค่าภาษาเป็น "ตรวจจับอัตโนมัติ"',
  'components.gettingStartedTour.scribeTour.step7.title': 'คลิกแก้ไขเพื่อปรับปรุงบทถอดความ',
  'components.gettingStartedTour.scribeTour.step7.text': 'การเปลี่ยนแปลงของคุณจะปรากฏเป็นสีทอง',
  'components.gettingStartedTour.scribeTour.step8.title': 'คลิกบันทึกเพื่อเก็บการเปลี่ยนแปลงของคุณ',
  'components.gettingStartedTour.scribeTour.step8.text': 'การแก้ไขของคุณจะปรากฏเป็นสีทองก่อนบันทึก',
  'components.gettingStartedTour.searchTour.completeModal.title': 'ทำได้ดีเยี่ยม!',
  'components.gettingStartedTour.tourButton.label': 'ทัวร์แนะนำ',
  'components.gettingStartedTour.tourCompleteModal.features.chat': 'ถามคำถามในแชท',
  'components.gettingStartedTour.tourCompleteModal.features.search': 'ค้นหาข้ามเอกสาร',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': 'ถอดความด้วย Scribe',
  'components.gettingStartedTour.tourCompleteModal.features.review': 'วิเคราะห์ด้วย Review',
  'components.gettingStartedTour.tourCompleteModal.progressText': 'ทำเสร็จแล้ว 5 จาก 5 ฟีเจอร์',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': 'เริ่มใช้งาน A&GEL →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix': 'ต้องการความช่วยเหลือ? ไปที่ ',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': 'คู่มือผู้ใช้',
  'components.lLMMetrics.status.fast': 'เร็ว',
  'components.lLMMetrics.status.slow': 'ช้า',
  'components.lLMMetrics.status.busy': 'ไม่ว่าง',
  'components.lLMMetrics.status.pending': 'รอดำเนินการ',
  'components.lLMMetrics.status.loading': 'กำลังโหลด',
  'components.lLMMetrics.metricBox.defaultChartLabel': 'ค่า',
  'components.management.passwordModal.usernameColumn': 'ชื่อผู้ใช้',
  'components.management.passwordModal.passwordColumn': 'รหัสผ่าน',
  'components.menuPanel.untitledItem': '(ไม่มีชื่อ)',
  'components.menuPanel.renameFailed': 'เปลี่ยนชื่อไม่สำเร็จ',
  'components.menuPanel.deleteConfirm.title': 'ลบรายการประวัติ',
  'components.menuPanel.deleteConfirm.createdLabel': 'สร้างเมื่อ:',
  'components.menuPanel.deleteSuccess': 'ลบรายการประวัติสำเร็จ',
  'components.menuPanel.deleteFailed': 'ลบรายการประวัติไม่สำเร็จ',
  'components.menuPanel.searchHistoryButton': 'ค้นหาประวัติ',
  'components.menuPanel.historyLabel': 'ประวัติ',
  'components.menuPanel.showAllButton': 'แสดงทั้งหมด',
  'components.menuPanel.showFavoritesButton': 'แสดงรายการโปรด',
  'components.menuPanel.endOfListMessage': '- สิ้นสุดรายการ -',
  'components.message.enhanceGpt.modalTitle': 'ปรับปรุงคำตอบของ GPT',
  'components.message.enhanceGpt.successMessage': 'บันทึกคำตอบใหม่แล้ว',
  'components.message.enhanceGpt.questionLabel': 'คำถาม: {question}',
  'components.message.enhanceGpt.answerLabel': 'คำตอบ',
  'components.message.postback.clickedLabel': 'คลิกแล้ว:',
  'components.message.postback.chatbotButtonFallback': 'ปุ่มแชทบอท',
  'components.message.locationLabel': 'ตำแหน่งที่ตั้ง',
  'components.message.stickerLabel': 'สติกเกอร์',
  'components.message.audiosLabel': 'ไฟล์เสียง',
  'components.message.imagesLabel': 'รูปภาพ',
  'components.message.videosLabel': 'วิดีโอ',
  'components.msgViewer.fromLabel': 'จาก:',
  'components.msgViewer.toLabel': 'ถึง:',
  'components.msgViewer.attachmentsLabel': 'ไฟล์แนบ:',
  'components.pdfViewerWithHighlight.renderError': 'ไม่สามารถแสดงผล PDF ได้',
  'components.promptSelector.copySuccess': 'คัดลอกพรอมป์แล้ว!',
  'components.promptSelector.copyError': 'ไม่สามารถคัดลอกพรอมป์ได้',
  'components.promptSelector.noResultsFiltered': 'ไม่พบพรอมป์ที่ตรงกับตัวกรองของคุณ',
  'components.promptSelector.startTyping': 'เริ่มพิมพ์เพื่อค้นหาพรอมป์',
  'components.promptSelector.promptLoaded': 'โหลดพรอมป์แล้ว!',
  'components.promptSelector.untitledPrompt': 'พรอมป์ไม่มีชื่อ',
  'components.promptSelector.actionPlaceholder': 'การดำเนินการ',
  'components.promptSelector.actionOption.summarise': 'สรุป',
  'components.promptSelector.actionOption.review': 'ตรวจสอบ',
  'components.promptSelector.actionOption.amend': 'แก้ไข',
  'components.promptSelector.actionOption.draft': 'ร่าง',
  'components.promptSelector.actionOption.redFlagging': 'ตั้งข้อสังเกตความเสี่ยง',
  'components.promptSelector.audiencePlaceholder': 'กลุ่มเป้าหมาย',
  'components.promptSelector.audienceOption.personal': 'ส่วนตัว',
  'components.promptSelector.audienceOption.group': 'กลุ่ม',
  'components.promptSelector.audienceOption.public': 'สาธารณะ',
  'components.promptSelector.selectPromptHint': 'เลือกพรอมป์เพื่อโหลดลงในช่องพิมพ์ข้อความ',
  'components.promptSelector.usePromptButton': 'ใช้พรอมป์นี้',
  'components.promptSelector.authorLabel': 'ผู้เขียน',
  'components.promptSelector.promptLabel': 'พรอมป์',
  'components.promptSelector.tagsLabel': 'แท็ก',
  'components.promptSelector.documentsAttached': 'จะแนบเอกสาร {count} ฉบับ',
  'components.questionListSelection.untitledQuestionList': '(ไม่มีชื่อ)',
  'components.questionListSelection.questionCount': '{count} คำถาม',
  'components.questionListSelection.accessPublicTag': 'สาธารณะ',
  'components.questionListSelection.accessFirmTag': 'บริษัท',
  'components.questionListSelection.accessGroupTag': 'กลุ่มส่วนตัว',
  'components.questionListSelection.viewLess': 'ดูน้อยลง',
  'components.questionListSelection.viewAll': 'ดูทั้งหมด',
  'components.questionListSelection.tourTooltip': 'เริ่มทัวร์แนะนำ',
  'components.questionListSelection.tourButton': 'ทัวร์แนะนำ',
  'components.questionListSelection.sortMostPopular': 'เรียงตาม: ยอดนิยม',
  'components.questionListSelection.sortNameAsc': 'เรียงตาม: ชื่อ A-Z',
  'components.questionListSelection.sortNameDesc': 'เรียงตาม: ชื่อ Z-A',
  'components.questionListSelection.filterByAudiencePlaceholder': 'กรองตามกลุ่มเป้าหมาย',
  'components.questionListSelection.audienceOptionPersonal': 'ส่วนตัว',
  'components.questionListSelection.audienceOptionPublic': 'สาธารณะ',
  'components.questionListSelection.filterByAuthorPlaceholder': 'กรองตามผู้เขียน',
  'components.reference.unknownAuthor': 'ไม่ทราบ',
  'components.reference.timeAgo.justNow': 'เมื่อสักครู่',
  'components.reference.timeAgo.hoursAgo': '{count, plural, other {# ชั่วโมงที่แล้ว}}',
  'components.reference.timeAgo.daysAgo': '{count, plural, other {# วันที่แล้ว}}',
  'components.reference.openCellDetails': 'เปิดรายละเอียดเซลล์',
  'components.reference.answerLabel': 'คำตอบ: ',
  'components.reference.explanationLabel': 'คำอธิบาย',
  'components.reference.verifiedLabel': 'ยืนยันแล้ว',
  'components.reference.verifyLabel': 'ยืนยัน',
  'components.reference.pleaseEnterComment': 'กรุณากรอกความคิดเห็น',
  'components.reference.commentAddedSuccess': 'เพิ่มความคิดเห็นสำเร็จ',
  'components.reference.failedToAddComment': 'ไม่สามารถเพิ่มความคิดเห็นได้',
  'components.reference.commentUpdatedSuccess': 'อัปเดตความคิดเห็นสำเร็จ',
  'components.reference.updateOwnCommentsOnly':
    'คุณสามารถอัปเดตได้เฉพาะความคิดเห็นของคุณเองเท่านั้น',
  'components.reference.failedToUpdateComment': 'ไม่สามารถอัปเดตความคิดเห็นได้',
  'components.reference.commentDeletedSuccess': 'ลบความคิดเห็นสำเร็จ',
  'components.reference.deleteOwnCommentsOnly': 'คุณสามารถลบได้เฉพาะความคิดเห็นของคุณเองเท่านั้น',
  'components.reference.failedToDeleteComment': 'ไม่สามารถลบความคิดเห็นได้',
  'components.reference.deleteComment.title': 'ลบความคิดเห็น',
  'components.reference.deleteComment.description': 'คุณแน่ใจหรือไม่ว่าต้องการลบความคิดเห็นนี้',
  'components.reference.addCommentPlaceholder': 'เพิ่มความคิดเห็น...',
  'components.reference.selectCellAriaLabel': 'เลือกเซลล์',
  'components.reference.selectQuestionRowAriaLabel': 'เลือกแถวคำถาม',
  'components.reference.selectDocumentColumnAriaLabel': 'เลือกคอลัมน์เอกสาร',
  'components.reference.selectDocumentRowAriaLabel': 'เลือกแถวเอกสาร',
  'components.reference.selectQuestionColumnAriaLabel': 'เลือกคอลัมน์คำถาม',
  'components.reference.documentsHeader': 'เอกสาร',
  'components.reference.addRow': 'เพิ่มแถว',
  'components.reference.addColumn': 'เพิ่มคอลัมน์',
  'components.reference.inverse': 'กลับด้าน',
  'components.reference.showAllColumns': 'แสดงคอลัมน์ทั้งหมด',
  'components.reference.showAllRows': 'แสดงแถวทั้งหมด',
  'components.reference.resetView': 'รีเซ็ตมุมมอง',
  'components.reference.summaryView': 'มุมมองสรุป',
  'components.reference.exactQuote': 'ข้อความอ้างอิงต้นฉบับ',
  'components.reference.exactQuoteView': 'มุมมองข้อความอ้างอิงต้นฉบับ',
  'components.reference.detailedView': 'มุมมองรายละเอียด',
  'components.reference.exitSelectMode': 'ออก',
  'components.reference.chatWithSelectedOutput': 'แชทกับผลลัพธ์ที่เลือก',
  'components.reference.selectCells': 'เลือกเซลล์',
  'components.referencePopover.fileLinkUnavailable': 'ลิงก์ไฟล์ไม่พร้อมใช้งาน',
  'components.referencePopover.failedToOpenNewTab': 'ไม่สามารถเปิดแท็บใหม่ได้',
  'components.referencePopover.failedToOpenFile': 'ไม่สามารถเปิดไฟล์ได้',
  'components.referencePopover.openInNewTab': 'เปิดเอกสารในแท็บใหม่ ↗',
  'components.rightContent.organisationSwitcher.switching': 'กำลังสลับองค์กร...',
  'components.rightContent.organisationSwitcher.switchError': 'ไม่สามารถสลับองค์กรได้',
  'components.rightContent.organisationSwitcher.unknownOrg': 'ไม่ทราบองค์กร',
  'components.rightContent.organisationSwitcher.defaultLabel': 'องค์กร',
  'components.rightContent.organisationSwitcher.tooltipFallback': 'สลับองค์กร',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.rightContent.angelTeamsButton.label': 'ติดต่อเรา',
  'components.rightContent.reportBug.label': 'รายงานข้อบกพร่อง',
  'components.rightContent.reportBug.contactSectionTitle': 'ติดต่อ',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': 'รายละเอียดข้อบกพร่อง',
  'components.rightContent.reportBug.environmentSectionTitle': 'สภาพแวดล้อม',
  'components.rightContent.reportBug.namePlaceholder': 'กรอกชื่อของคุณ',
  'components.rightContent.reportBug.nameRequired': 'กรุณากรอกชื่อของคุณ',
  'components.rightContent.reportBug.emailLabel': 'อีเมล',
  'components.rightContent.reportBug.emailPlaceholder': 'กรอกอีเมลของคุณ',
  'components.rightContent.reportBug.emailRequired': 'กรุณากรอกอีเมลของคุณ',
  'components.rightContent.reportBug.emailInvalid': 'กรุณากรอกอีเมลให้ถูกต้อง',
  'components.rightContent.reportBug.locationLabel': 'พบข้อบกพร่องที่ใด',
  'components.rightContent.reportBug.locationPlaceholder': 'เลือกฟังก์ชัน',
  'components.rightContent.reportBug.locationRequired': 'กรุณาระบุตำแหน่งที่พบข้อบกพร่อง',
  'components.rightContent.reportBug.descriptionLabel': 'อธิบายปัญหา',
  'components.rightContent.reportBug.descriptionRequired': 'กรุณาอธิบายปัญหา',
  'components.rightContent.reportBug.filesLabel': 'ภาพหน้าจอหรือการบันทึกวิดีโอ',
  'components.rightContent.reportBug.uploadText': 'คลิกหรือลากเพื่ออัปโหลด',
  'components.rightContent.reportBug.fileSizeKb': '{size} KB',
  'components.rightContent.reportBug.removeFile': 'ลบ {fileName}',
  'components.rightContent.reportBug.deviceLabel': 'อุปกรณ์',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': 'กรุณาระบุอุปกรณ์ของคุณ',
  'components.rightContent.reportBug.osLabel': 'ระบบปฏิบัติการและเวอร์ชัน',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': 'กรุณาระบุระบบปฏิบัติการของคุณ',
  'components.rightContent.reportBug.browserLabel': 'เบราว์เซอร์',
  'components.rightContent.reportBug.browserPlaceholder': 'เลือกเบราว์เซอร์',
  'components.rightContent.reportBug.browserRequired': 'กรุณาระบุเบราว์เซอร์ของคุณ',
  'components.rightContent.reportBug.submitSuccess': 'ส่งรายงานข้อบกพร่องสำเร็จ!',
  'components.rightContent.reportBug.submitError':
    'ไม่สามารถส่งรายงานข้อบกพร่องได้ กรุณาลองใหม่อีกครั้ง',
  'components.rightContent.reportBug.invalidFileType':
    'คุณสามารถอัปโหลดได้เฉพาะไฟล์รูปภาพหรือวิดีโอเท่านั้น!',
  'components.rightContent.reportBug.fileUploadSuccess': 'อัปโหลดไฟล์ "{fileName}" สำเร็จ!',
  'components.rightContent.reportBug.fileUploadError': 'ไม่สามารถอัปโหลดไฟล์ได้',
  'components.rightContent.reportBug.page.home': 'หน้าแรก',
  'components.rightContent.reportBug.page.chat': 'แชท',
  'components.rightContent.reportBug.page.composer': 'Composer',
  'components.rightContent.reportBug.page.review': 'รีวิว',
  'components.rightContent.reportBug.page.reference': 'อ้างอิง',
  'components.rightContent.reportBug.page.files': 'ไฟล์',
  'components.rightContent.reportBug.page.userProfile': 'โปรไฟล์ผู้ใช้',
  'components.rightContent.reportBug.page.other': 'อื่นๆ',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.other': 'อื่นๆ',
  'components.rightContent.receiptModal.title': 'ขอบคุณ',
  'components.rightContent.receiptModal.description': 'ส่งรายงานของคุณเรียบร้อยแล้ว',
  'components.scribe.clickToStartRecording': 'คลิกเพื่อเริ่มบันทึก',
  'components.scribe.failedToGetAuthToken': 'ไม่สามารถรับโทเคนยืนยันตัวตนได้',
  'components.scribe.failedToStartRecording': 'ไม่สามารถเริ่มบันทึกได้',
  'components.searchPdfViewerWithHighlight.renderError': 'ไม่สามารถแสดงผล PDF ได้',
  'components.themeToggle.themeSectionLabel': 'ธีม',
  'components.themeToggle.themeTeal': '🌊 น้ำเงินเขียว',
  'components.themeToggle.themeMaroon': '🍷 มารูน',
  'components.themeToggle.modeSectionLabel': 'โหมด',
  'components.themeToggle.lightMode': 'สว่าง',
  'components.themeToggle.darkMode': 'มืด',
  'components.themeToggle.themeSettingsTooltip': 'การตั้งค่าธีม',
  'components.whatsNewModal.title': 'มีอะไรใหม่',
  'components.whatsNewModal.intro':
    'เราได้เพิ่มฟีเจอร์ใหม่หลายรายการเพื่อยกระดับกระบวนการตรวจสอบเอกสารของคุณ:',
  'components.whatsNewModal.feature1.title': 'การกรองที่ดีขึ้น: ',
  'components.whatsNewModal.feature1.description':
    'ตัวกรองกลุ่มเป้าหมายและผู้เขียนใหม่ ช่วยให้คุณค้นหารายการคำถามได้เร็วขึ้น',
  'components.whatsNewModal.feature2.title': 'คำถามเฉพาะกิจ: ',
  'components.whatsNewModal.feature2.description':
    'วิธีเพิ่มคำถามได้อย่างยืดหยุ่นมากขึ้นตามต้องการ',
  'components.whatsNewModal.feature3.title': 'การปรับปรุง UI: ',
  'components.whatsNewModal.feature3.description':
    'อินเทอร์เฟซที่สะอาดตาและใช้งานง่ายขึ้นสำหรับการจัดการ {featureName} ของคุณ',
  'components.whatsNewModal.upcomingFeatures.title': 'ฟีเจอร์ที่กำลังจะมาถึง',
  'components.whatsNewModal.upcomingFeatures.description':
    'โปรดติดตามอัปเดตเพิ่มเติม รวมถึงการตรวจสอบร่วมกันและการวิเคราะห์ AI ขั้นสูง',
  'components.user.uidLabel': 'UID',
  'components.user.idCopiedMessage': 'คัดลอก ID แล้ว!',
  'components.file.manager.fetchGroupError': 'ไม่สามารถดึงข้อมูลกลุ่มได้: {message}',
  'components.file.manager.fetchFilesError': 'ไม่สามารถดึงข้อมูลไฟล์ได้: {message}',
  'components.file.manager.breadcrumbRoot': 'เส้นทาง',
  'components.file.manager.breadcrumbBackUpLevel': 'ย้อนกลับหนึ่งระดับ',
  'components.file.manager.searchPlaceholder': 'ค้นหาไฟล์หรือโฟลเดอร์',
  'components.file.manager.uploadFileButton': 'อัปโหลดไฟล์',
  'components.file.manager.createFolderButton': 'สร้างโฟลเดอร์',
  'components.file.manager.enterButton': 'เข้า',
  'components.file.manager.deleteFolderButton': 'ลบโฟลเดอร์',
  'components.file.manager.deleteFileButton': 'ลบไฟล์',
  'components.file.manager.uploadedByTime': 'อัปโหลดโดย: {username}, เวลาอัปโหลด: {createdAt}',
  'components.file.manager.folderNamePlaceholder': 'ชื่อโฟลเดอร์',
  'components.file.filePreview.cannotPreview': 'ไม่สามารถแสดงตัวอย่างไฟล์ประเภทนี้ได้',
  'components.file.documentSelector.sortNameAsc': 'ชื่อ (ก-ฮ)',
  'components.file.documentSelector.sortNameDesc': 'ชื่อ (ฮ-ก)',
  'components.file.documentSelector.sortNewestFirst': 'ใหม่สุดก่อน',
  'components.file.documentSelector.sortOldestFirst': 'เก่าสุดก่อน',
  'components.file.documentSelector.favourites': 'รายการโปรด',
  'components.file.documentSelector.selectedCount': 'เลือกแล้ว ({count}):',
  'components.file.documentSelector.selectAllFilesInFolder': 'เลือกไฟล์ทั้งหมดใน {folderName}',
  'components.file.documentSelector.noFiles': 'ไม่มีไฟล์',
  'components.file.documentSelector.folderAlt': 'โฟลเดอร์',
  'components.file.documentSelector.fileAlt': 'ไฟล์',
  'components.file.documentSelector.selectDocuments': 'เลือกเอกสาร',
  'components.file.documentSelector.selectOkText': 'เลือก',
  'components.file.fileTree.uploadFailed': 'อัปโหลด {fileName} ไม่สำเร็จ',
  'components.file.fileTree.clickOrDragToUpload': 'คลิกหรือลากเพื่ออัปโหลด',
  'components.file.fileTree.noFilesUploadedOrSelected': 'ยังไม่มีไฟล์ที่อัปโหลดหรือเลือกไว้',
  'components.file.selectContext.cannotDeleteDefaultContext':
    'คุณไม่สามารถลบบริบทเริ่มต้นได้ กรุณาตั้งค่าบริบทอื่นเป็นค่าเริ่มต้นก่อน',
  'components.file.selectContext.contextDeleted': 'ลบบริบทแล้ว',
  'components.file.selectContext.deleteContextFailed': 'ไม่สามารถลบบริบทได้',
  'components.file.selectContext.enterContextNameWarning': 'กรุณาระบุชื่อบริบท',
  'components.file.selectContext.contextCreated': 'สร้างบริบทแล้ว',
  'components.file.selectContext.cannotUnsetDefaultContext':
    'คุณไม่สามารถยกเลิกบริบทเริ่มต้นนี้ได้ กรุณาตั้งค่าบริบทอื่นเป็นค่าเริ่มต้นก่อน',
  'components.file.selectContext.contextUpdated': 'อัปเดตบริบทแล้ว',
  'components.file.selectContext.createContextFailed': 'ไม่สามารถสร้างบริบทได้',
  'components.file.selectContext.updateContextFailed': 'ไม่สามารถอัปเดตบริบทได้',
  'components.file.selectContext.selectContextPresetPlaceholder': 'เลือกบริบทที่กำหนดไว้ล่วงหน้า',
  'components.file.selectContext.defaultLabel': '(ค่าเริ่มต้น)',
  'components.file.selectContext.deleteContextConfirmTitle': 'ลบบริบทนี้หรือไม่',
  'components.file.selectContext.deleteContextConfirmDescription':
    'การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  'components.file.selectContext.addNewContextTooltip': 'เพิ่มบริบทใหม่',
  'components.file.selectContext.modifyContextInfoTooltip': 'แก้ไขข้อมูลบริบท',
  'components.file.selectContext.newContextLabel': 'บริบทใหม่',
  'components.file.selectContext.editContextLabel': 'แก้ไขบริบท',
  'components.file.selectContext.contextTitlePlaceholder': 'ชื่อบริบท',
  'components.file.selectContext.setAsDefaultLabel': 'ตั้งเป็นค่าเริ่มต้น',
  'components.file.selectContext.contextSelectionTitle': 'การเลือกบริบท',
  'components.file.selectContext.noContextSelected': 'ไม่ได้เลือกบริบท',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    'ฟีเจอร์ขั้นสูงสำหรับผู้ที่ต้องการก้าวไปอีกขั้น',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': 'มีอะไรใหม่',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    'อัปโหลดไฟล์อีเมลทั้งหมดเข้าสู่ A&GEL รวมถึงไฟล์แนบ และใช้งานได้เหมือนเอกสารทั่วไป',
  'components.gettingStartedTour.allCompleted.title': 'คุณทำทัวร์ A&GEL ครบทั้งหมดแล้ว!',
  'components.gettingStartedTour.chatTour.step1.title':
    'เราได้โหลดตัวอย่างสัญญา NDA ให้คุณแล้ว คลิก Context เพื่อดู',
  'components.gettingStartedTour.chatTour.step1.text':
    'ที่นี่คือจุดที่คุณจัดการเอกสารที่ A&GEL ใช้อ้างอิงในการตอบคำถาม',
  'components.gettingStartedTour.chatTour.step2.title': 'นี่คือเอกสารที่โหลดไว้ของคุณ',
  'components.gettingStartedTour.chatTour.step2.text':
    'คุณสามารถอัปโหลดไฟล์หรือเลือกจาก Vault ของคุณ ปิดแผงเมื่อพร้อมแล้ว',
  'components.gettingStartedTour.chatTour.step3.title':
    'เราได้เตรียมคำถามไว้ให้คุณแล้ว คลิกส่งเพื่อถามเกี่ยวกับ NDA',
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay':
    'ข้อผูกพันด้านการรักษาความลับในข้อตกลงนี้มีอะไรบ้าง',
  'components.gettingStartedTour.chatTour.step4.title':
    'คำตอบดีมาก! ตอนนี้คลิกหมายเลขอ้างอิง (เช่น [1]) เพื่อดูเอกสารต้นฉบับ',
  'components.gettingStartedTour.chatTour.step4.text':
    'การอ้างอิงจะเชื่อมโยงกลับไปยังส่วนที่แน่นอนของเอกสารที่ AI ใช้',
  'components.gettingStartedTour.chatTour.completeModal.description':
    'คุณได้ถามคำถามแรกใน Chat และได้รับคำตอบพร้อมการอ้างอิงแล้ว',
  'components.gettingStartedTour.tourComplete.progressText':
    'ทำเสร็จแล้ว {completedCount} จาก 5 ฟีเจอร์',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    'คุณได้ใช้การแก้ไขเพิ่มเติมด้วย Workstudio แล้ว',
  'components.gettingStartedTour.playbookTour.step1.title':
    'เราได้โหลดตัวอย่างข้อตกลงกับผู้ขายที่ต้องมีการแก้ไขเพิ่มเติม',
  'components.gettingStartedTour.playbookTour.step1.text':
    'คุณคือผู้ขาย (Pand.ai) ที่กำลังขอเงื่อนไขที่ดีกว่าจากลูกค้า',
  'components.gettingStartedTour.playbookTour.step2.title':
    'เราได้ร่างคำขอแก้ไขเพิ่มเติม 3 รายการ:',
  'components.gettingStartedTour.playbookTour.step2.text':
    'โหมดหลายขั้นตอนจะประมวลผลแต่ละรายการพร้อมกันเพื่อผลลัพธ์ที่เร็วขึ้น',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL จะแสดงการเปลี่ยนแปลงที่ติดตามไว้ ซึ่งคุณสามารถยอมรับ ปฏิเสธ หรือดาวน์โหลดได้',
  'components.gettingStartedTour.playbookTour.step4.title':
    'นี่คือการแก้ไขเพิ่มเติมที่ A&GEL ร่างขึ้นจากคำสั่งของคุณ',
  'components.gettingStartedTour.playbookTour.step4.text':
    'แต่ละการ์ดจะแสดงข้อความต้นฉบับและการเปลี่ยนแปลงที่เสนอ',
  'components.gettingStartedTour.playbookTour.step5.title':
    'ตรวจสอบการแก้ไขเพิ่มเติมนี้แล้วยอมรับหรือปฏิเสธ',
  'components.gettingStartedTour.playbookTour.step5.text':
    'คุณสามารถทำแบบเดียวกันนี้กับรายการที่เหลือได้ในภายหลัง',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    'คุณได้สร้างรายการคำถามและใช้ตรวจสอบเอกสารแล้ว',
  'components.gettingStartedTour.reviewTour.step1.title':
    'Review ตอบคำถามของคุณในหลายเอกสารโดยใช้รายการคำถาม',
  'components.gettingStartedTour.reviewTour.step1.text':
    'คุณสามารถสร้างรายการคำถามของคุณเองหรือใช้รายการที่มีอยู่แล้วได้',
  'components.gettingStartedTour.reviewTour.step2.title': 'เรียกดูรายการคำถามสำเร็จรูปตามหมวดหมู่',
  'components.gettingStartedTour.reviewTour.step3.title':
    'มาสร้างรายการของคุณเองกันเถอะ คลิกที่นี่เพื่อเริ่มสร้างรายการคำถามใหม่',
  'components.gettingStartedTour.reviewTour.step5.title':
    'นี่คือตัวอย่างคำถามบางส่วนที่เพิ่มเข้าไปในรายการของคุณเป็นแถวที่แก้ไขได้',
  'components.gettingStartedTour.reviewTour.step6.title':
    'คำถามของคุณจะแสดงที่นี่เป็นแถวที่แก้ไขได้ คุณสามารถลบได้ทุกเมื่อ หรือเพิ่มส่วนเพื่อจัดกลุ่ม',
  'components.gettingStartedTour.reviewTour.step7.title':
    'อธิบายว่ารายการนี้มีไว้เพื่ออะไร — ปรับให้เหมาะกับความต้องการของคุณ',
  'components.gettingStartedTour.reviewTour.step8.title':
    'ปรับแต่งวิธีที่ AI ตอบคำถาม — น้ำเสียง รูปแบบ และระดับความละเอียด',
  'components.gettingStartedTour.reviewTour.step10.title':
    'เราได้โหลดเอกสารตัวอย่างไว้ให้คุณลองใช้งาน',
  'components.gettingStartedTour.reviewTour.step10.text':
    'รายการคำถามของคุณพร้อมใช้งานกับเอกสารเหล่านี้แล้ว',
  'components.gettingStartedTour.reviewTour.step11.title':
    'กดส่งเพื่อเรียกใช้การตรวจสอบกับเอกสารทั้งหมด',
  'components.gettingStartedTour.reviewTour.step12.title':
    'แต่ละแถวคือคำถาม แต่ละคอลัมน์คือเอกสาร คำตอบจะถูกดึงออกมาโดยอัตโนมัติ',
  'components.gettingStartedTour.reviewTour.step13.title': 'คลิกคำตอบใดก็ได้เพื่อดูที่มาที่แน่นอน',
  'components.gettingStartedTour.reviewTour.step14.title':
    'คลิกหมายเลขอ้างอิงเพื่อกระโดดไปยังข้อความที่แน่นอนในเอกสารต้นฉบับ',
  'components.gettingStartedTour.reviewTour.step15.title':
    'นี่คือขั้นตอนการ Review ทั้งหมด — แหล่งที่มาอยู่ห่างเพียงคลิกเดียวเสมอ คุณทำเสร็จแล้ว!',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    'คุณได้ถอดเสียงด้วย Scribe แล้ว',
  'components.gettingStartedTour.scribeTour.step1.title':
    'เลือกว่าคุณจะใช้ข้อความถอดเสียงนี้เพื่ออะไร',
  'components.gettingStartedTour.scribeTour.step1.text':
    'สิ่งนี้ช่วยให้ A&GEL จัดรูปแบบผลลัพธ์ได้ โดย "บันทึกการประชุม" ถูกเลือกไว้แล้ว',
  'components.gettingStartedTour.scribeTour.step2.text':
    'คุณยังสามารถเปิดใช้การแปลสดเพื่อดูคำแปลแบบเรียลไทม์ได้',
  'components.gettingStartedTour.scribeTour.step3.title':
    'คลิกปุ่มบันทึกเสียง หรืออัปโหลดไฟล์เสียงที่มีอยู่แล้ว',
  'components.gettingStartedTour.scribeTour.step4.title':
    'คลิกหยุดเมื่อคุณพร้อมบันทึกข้อความถอดเสียง',
  'components.gettingStartedTour.scribeTour.step5.title':
    'พิมพ์ชื่อสำหรับข้อความถอดเสียงของคุณ แล้วคลิกบันทึก',
  'components.gettingStartedTour.scribeTour.step6.title':
    'คลิกบรรทัดข้อความถอดเสียงใดก็ได้เพื่อเล่นเสียงจากจุดนั้น',
  'components.gettingStartedTour.searchTour.completeModal.description':
    'คุณได้ค้นหาในเอกสารและพบข้อสัญญาที่เกี่ยวข้องแล้ว',
  'components.gettingStartedTour.searchTour.step1.title': 'เราได้เตรียมคำค้นหาไว้ให้คุณแล้ว',
  'components.gettingStartedTour.searchTour.step1.text':
    'คลิกค้นหา หรือกด Enter เพื่อค้นหาข้อสัญญาที่ตรงกัน',
  'components.gettingStartedTour.searchTour.step2.title':
    'นี่คือผลลัพธ์ที่ตรงกันจาก NDA คลิกที่เอกสารเพื่อดูผลลัพธ์ที่ตรงกันทั้งหมดภายใน',
  'components.gettingStartedTour.searchTour.step3.title':
    'คลิกส่วนใดก็ได้เพื่อกระโดดไปยังส่วนนั้นในเอกสาร',
  'components.gettingStartedTour.searchTour.step3.text':
    'ทางซ้ายคุณจะเห็นข้อความที่ตรงกัน ทางขวาคือเอกสารฉบับเต็มพร้อมคำสำคัญที่ไฮไลต์ไว้',
  'components.gettingStartedTour.tourCompleteModal.features.playbook':
    'ใช้การแก้ไขเพิ่มเติมใน Workstudio',
  'components.gettingStartedTour.tourCompleteModal.title': 'พร้อมใช้งานแล้ว!',
  'components.gettingStartedTour.tourCompleteModal.subtitle':
    'คุณทำทัวร์ A&GEL เสร็จแล้ว และได้เรียนรู้วิธี:',
  'components.management.passwordModal.createHeader':
    'คุณสร้างผู้ใช้สำเร็จแล้ว โดยมีข้อมูลรับรองดังนี้:',
  'components.management.passwordModal.emailChangeHeader':
    'คุณเปลี่ยนอีเมลผู้ใช้สำเร็จแล้ว ข้อมูลรับรองใหม่มีดังนี้:',
  'components.management.passwordModal.changePasswordNotice':
    '*ผู้ใช้จะต้องเปลี่ยนรหัสผ่านหลังจากเข้าสู่ระบบครั้งแรก',
  'components.menuPanel.deleteConfirm.content':
    'คุณแน่ใจหรือไม่ว่าต้องการลบรายการประวัตินี้ การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  'components.questionListSelection.whatsNewButton': 'มีอะไรใหม่',
  'components.reference.timeAgo.minutesAgo': '{count, plural, other {# นาทีที่แล้ว}}',
  'components.reference.matrixIdRequired':
    'ต้องระบุ Matrix ID กรุณาตรวจสอบว่าได้ส่ง prop matrixId ไปยังคอมโพเนนต์ Reference แล้ว',
  'components.reference.cellsSelected': '{count, plural, other {เลือกไว้ # เซลล์}}',
  'components.rightContent.organisationSwitcher.switchSuccess': 'สลับองค์กรสำเร็จแล้ว',
  'components.rightContent.organisationSwitcher.switchNoToken':
    'การสลับองค์กรไม่ได้ส่งคืนโทเค็นใหม่',
  'components.rightContent.reportBug.modalDescription':
    'แจ้งให้เราทราบถึงปัญหาที่คุณพบโดยกรอกแบบฟอร์มด้านล่าง',
  'components.appShell.logoutMenuItem': 'ออกจากระบบ',
  'components.appShell.unauthorized.title': 'หน้านี้ไม่ได้มีไว้สำหรับคุณ',
  'components.appShell.unauthorized.backHome': 'กลับสู่หน้าหลัก',
  'components.appShell.promptLibrary.title': 'คลังพรอมต์',
  'components.appShell.promptLibrary.noPromptsAvailable': 'ไม่มีพรอมต์ที่ใช้ได้',
  'components.appShell.promptLibrary.copyTooltip': 'คัดลอกเนื้อหาพรอมต์',
  'components.appShell.promptLibrary.untitledPrompt': 'พรอมต์ที่ไม่มีชื่อ',
  'components.appShell.promptLibrary.copiedMessage': 'คัดลอกพรอมต์ไปยังคลิปบอร์ดแล้ว!',
  'components.appShell.clipboard.title': 'คลิปบอร์ด',
  'components.appShell.clipboard.copiedMessage': 'คัดลอกแล้ว!',
  'components.appShell.notFound.title': 'ไม่พบหน้านี้',
  'components.gettingStartedTour.tourTask.chat.title': 'แชท',
  'components.gettingStartedTour.tourTask.chat.duration': '~1 นาที',
  'components.gettingStartedTour.tourTask.search.title': 'ค้นหา',
  'components.gettingStartedTour.tourTask.search.duration': '~1 นาที',
  'components.gettingStartedTour.tourTask.scribe.title': 'บันทึกเสียง',
  'components.gettingStartedTour.tourTask.scribe.duration': '~2 นาที',
  'components.gettingStartedTour.tourTask.review.title': 'ตรวจสอบ',
  'components.gettingStartedTour.tourTask.review.duration': '~3 นาที',
  'components.gettingStartedTour.tourTask.playbook.title': 'Workstudio',
  'components.gettingStartedTour.tourTask.playbook.duration': '~2 นาที',
  'components.matrixPolling.processingStoppedMessage': 'หยุดการประมวลผลแล้ว',
  'components.matrixPolling.stopProcessingFailedMessage': 'หยุดการประมวลผลไม่สำเร็จ',
  'components.appShell.noResponseError': 'ไม่มีการตอบสนอง! กรุณาลองอีกครั้ง',
  'components.appShell.requestError': 'เกิดข้อผิดพลาดในการร้องขอ กรุณาลองอีกครั้ง',
  'components.appShell.requestFailedError': 'การร้องขอล้มเหลว!',
  'components.composerService.socketErrorPrefix': 'ข้อผิดพลาด: {message}',
  'components.composerService.sessionDisconnected':
    'เซสชัน Composer ถูกตัดการเชื่อมต่อเนื่องจากมีการเชื่อมต่ออื่น',
  'components.fileViewerWithToken.retrieveFailedError': 'ไม่สามารถเรียกข้อมูลไฟล์ได้',
  'components.languageSwitcher.switchLanguageTooltip': 'เปลี่ยนภาษา',
  'components.crossOrgBadge.sharedByLabel': 'แชร์โดย: {orgName}',
  'components.crossOrgBadge.externalOrganization': 'องค์กรภายนอก',
  'components.file.sharePoint.fromComputer': 'จากคอมพิวเตอร์เครื่องนี้',
  'components.file.sharePoint.fromSharePoint': 'จาก SharePoint / OneDrive',
  'components.file.sharePoint.orAddFromSharePoint': 'หรือเพิ่มจาก SharePoint / OneDrive',
  'components.file.sharePoint.account': 'บัญชี Microsoft',
  'components.file.sharePoint.useDifferentAccount': 'ใช้บัญชีอื่น',
  'components.file.sharePoint.disconnect': 'ยกเลิกการเชื่อมต่อ',
  'components.file.sharePoint.disconnectConfirm':
    'ยกเลิกการเชื่อมต่อบัญชี Microsoft ของคุณจาก A&GEL ใช่หรือไม่',
  'components.file.sharePoint.disconnected': 'ยกเลิกการเชื่อมต่อบัญชี Microsoft แล้ว',
  'components.file.sharePoint.popupBlocked':
    'โปรดอนุญาตป๊อปอัปสำหรับ A&GEL เพื่อเลือกไฟล์จาก SharePoint',
  'components.file.sharePoint.consentDeniedTitle': 'การเข้าถึง SharePoint ไม่ได้รับการอนุมัติ',
  'components.file.sharePoint.consentDenied':
    'การเข้าถึง SharePoint ไม่ได้รับการอนุมัติ หากองค์กรของคุณต้องการการอนุมัติจากผู้ดูแลระบบไอที โปรดขอให้ผู้ดูแลระบบไอทีอนุมัติ A&GEL',
  'components.file.sharePoint.copyApprovalLink': 'คัดลอกลิงก์อนุมัติสำหรับผู้ดูแลระบบไอที',
  'components.file.sharePoint.approvalLinkCopied': 'คัดลอกลิงก์อนุมัติแล้ว',
  'components.file.sharePoint.connectFailed': 'ไม่สามารถเชื่อมต่อกับ Microsoft ได้ โปรดลองอีกครั้ง',
  'components.file.sharePoint.reconnect': 'โปรดเชื่อมต่อบัญชี Microsoft ของคุณอีกครั้ง',
  'components.file.sharePoint.unsupportedType': '{name} ไม่ใช่ประเภทไฟล์ที่รองรับในที่นี้',
  'components.file.sharePoint.tooLarge': '{name} มีขนาดใหญ่เกินไป (สูงสุด {max} MB)',
  'components.file.sharePoint.rejected': 'ไม่สามารถเพิ่ม {name} ได้',
  'components.file.sharePoint.downloadFailed':
    'ไม่สามารถดึง {name} จาก SharePoint ได้ โปรดลองอีกครั้งหรืออัปโหลดจากคอมพิวเตอร์ของคุณ',
  'components.file.sharePoint.folderTooLarge':
    'โฟลเดอร์นี้ใหญ่เกินกว่าจะนำเข้าในครั้งเดียว (สูงสุด {max} ไฟล์) โปรดเลือกโฟลเดอร์ที่เล็กกว่า',
  'components.file.sharePoint.chooserTitle': 'เลือกไฟล์',
  'components.file.sharePoint.chooserMyFiles': 'ไฟล์ของฉัน',
  'components.file.sharePoint.chooserShared': 'แชร์',
  'components.file.sharePoint.chooserFollowedSites': 'ไซต์ที่ติดตาม',
  'components.file.sharePoint.chooserSearch': 'ค้นหาไซต์',
  'components.file.sharePoint.chooserName': 'ชื่อ',
  'components.file.sharePoint.chooserEmpty': 'คุณยังไม่ได้ติดตามไซต์ใด ค้นหาไซต์ด้านบน',
  'components.file.sharePoint.chooserLocked':
    'แสดงเฉพาะไซต์ที่คุณติดตามหรือค้นหาเท่านั้น โปรดขอให้ผู้ดูแลระบบไอทีอนุมัติ A&GEL เพื่อเรียกดูไซต์ทั้งหมด',
  'components.file.sharePoint.chooserLoading': 'กำลังโหลด…',
  'components.file.sharePoint.chooserSelect': 'เลือก',
  'components.file.sharePoint.chooserCancel': 'ยกเลิก',
};
